import config from '../config';
import { customFetch, authHeader, jsonHeader, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = 'app_metadata'

export const appMetadataService = {
    getByScope,
    updateByScope,
};

function getByScope(scope, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}?scope=${encodeURIComponent(scope)}`, requestOptions, signal).then(handleResponse);
}

function updateByScope(scope, patch, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(patch) };
    return customFetch(`${config.api.url}/${endpointPath}/${encodeURIComponent(scope)}`, requestOptions, signal).then(handleResponse);
}
